import React, {Component} from 'react';


export default class ResearcherGenerateResults extends Component
{
    render()
    {
        return (
            <React.Fragment>
                <section className="section-01-researcher-generate-results">

                    <div className="result-preview">

                        <div className="image-preview">
                            <img src="logo513.png" alt="Preview" />
                        </div>

                        <div className="download">
                            <button className="download-button">Download</button>
                        </div>

                    </div>

                </section>
            </React.Fragment>
        );
    }
}